import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { permissionAreaKeyNameOf } from "../../helpers/permission.helpers";
import { MenuQuantityItemEnum } from "../../models/menu/menu-quantity-item-enum";
import { WorkQueueArea } from "../../models/roles/role-accesses/work-queue-area";
import { NoteDetailsComponent } from "../../modules/tcm-common/components/note-details/note-details.component";
import { ModalGuard } from "../../routerGuards/modal.guard";
import { WorkQueueSubMenuGuard } from "../../routerGuards/work-queue-sub-menu.guard";
import { WorkQueueNoteLinkedSearchComponent } from "./components/work-queue-note-linked-search/work-queue-note-linked-search.component";

export function entityKeyResolver(name: Extract<keyof WorkQueueArea, string>): string { return name; };

export const workQueuesRoutes: Routes = [
    {
        path: 'unassigned',
        component: WorkQueueNoteLinkedSearchComponent,
        data: { areaPermissionKey: permissionAreaKeyNameOf("workQueue"),
            entityPermissionKey: entityKeyResolver("workQueues"),
            menuQuantityItem: MenuQuantityItemEnum.WorkQueue },
        //canActivate: [WorkQueueSubMenuGuard]
    },
    {
        path: ':workQueueId',
        component: WorkQueueNoteLinkedSearchComponent,
        data: { areaPermissionKey: permissionAreaKeyNameOf("workQueue"),
            entityPermissionKey: entityKeyResolver("workQueues"),
            menuQuantityItem: MenuQuantityItemEnum.WorkQueue },
        //canActivate: [WorkQueueSubMenuGuard]
    },    
    {
        path: 'notes/details',
        component: NoteDetailsComponent,
        canActivate: [ModalGuard],
        //canActivate: [ModalGuard, WorkQueueSubMenuGuard]
        data: { areaPermissionKey: permissionAreaKeyNameOf("workQueue"), 
            entityPermissionKey: entityKeyResolver("workQueues") },
    },
    {
        path: "**",
        pathMatch: "full",
        redirectTo: "/work-queues/unassigned"
    }       
]

@NgModule({
    imports: [RouterModule.forChild(workQueuesRoutes)],
    exports: [RouterModule],
    providers: [ModalGuard]
})
export class WorkQueueRoutingModule { }